import React,{useState,useEffect} from 'react';
import {Link,useNavigate} from 'react-router-dom';
import Topbar from '../../../layout/topbar';
import Footer from '../../../layout/footer';
import {APP_URL} from '../../../validation/basic';
import axios from 'axios';
import {ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AddMenu=()=>{
	const [menus,setMenus] = useState({
		menu:'',
		parent_menu:'0',
		menu_url:'',
		menu_order:'0'
	});
	const [token,setToken]=useState(localStorage.getItem('token'));
	const [menuerror,setMenuerror] = useState(false);
	const [parenterror,setParenterror] = useState(false);
	const [urlerror,setUrlerror] = useState(false);
	const [ordererror,setOrdererror] = useState(false);

	let navigate = useNavigate ();

	const [listmenu,setListmenu] =useState([]);
	const {menu,parent_menu,menu_url,menu_order} = menus;

	useEffect(()=>{
		setToken(localStorage.getItem('token'));
		getmenus();
	},[])
	const getmenus = async()=>{
		try{
				const menusdata = await axios.get(APP_URL+'menus',{ headers: {"Authorization" : `Bearer ${token}`}});
				let menuslist = JSON.parse(JSON.stringify(menusdata.data));
				if(menuslist.status==1){
					setListmenu(menuslist.data.menus);
				}

		}catch(e){
			return false;
		}
	}

	const handlechange = (e)=>{
		setMenus({...menus,[e.target.name]:e.target.value});
	}

	const validate_fields = ()=>{

		if(menus.menu==''){
			setMenuerror(true);
		}else{
			setMenuerror(false);
		}
		
		if(menus.menu_url==''){
			setUrlerror(true);
		}else{
			setUrlerror(false);
		}
		
	}

	const MenuSubmit = async()=>{
		validate_fields();
		if(menu!=''&&menu_url!=''){
			try{	
					let form = new FormData();
					form.append('menu_name',menu);
					form.append('slug',menu_url);
					form.append('parent_menu',parent_menu);
					form.append('order',menu_order);
					const response = await axios.post(APP_URL+'menus',form,{ headers: {"Authorization" : `Bearer ${token}`}});
					let response_data = JSON.parse(JSON.stringify(response.data));
					if(response_data.status==1){
						toast.success('menu created successfull');
						navigate('/master/manage/menu');						
					}

			}catch(e){
				toast.error('something went wrong');
				return false;
			}
		}else{
			return false;
		}	
	}


	return (
		<>
			<div id="app">
		        <div id="main" className="layout-horizontal">
		          <Topbar/>
		          <ToastContainer/>
					  <div className="content-wrapper container">           
					
					<div className="page-content">
					    <section className="row">    	
				        <div className="col-12 col-lg-12"> 
				        <section className="section">
				        <div className="row" id="table-hover-row">
				            <div className="col-12">
				                <div className="card">
				                    <div className="card-header" style={{borderBottom:'1px solid'}}>
				                    <h5>Add New Menu</h5>
				                 		                   
				                    </div>
				                    <div className="card-body mt-4">                     
				                       	
				                        <div className="row">
				                        	<div className="col-md-2"></div>
				                        	<div className="col-md-8">
				                        		<div className="row">
					                        		<div className="col-sm-3" style={{textAlign:'right'}}>
								                    <label>Menu Name</label>
									                </div>
									                <div className="col-sm-9 form-group">
									                    <input type="text" className={"form-control "+(menuerror==true?'invalid':null)} name="menu" placeholder="menu" onChange={(e)=>handlechange(e)} value={menu}/>
									                </div>
								                </div>

								                <div className="row">
					                        		<div className="col-sm-3" style={{textAlign:'right'}}>
								                    <label>Parent Menu</label>
									                </div>
									                <div className="col-sm-9 form-group">
									                    <select type="text" className={"form-control "+(parenterror==true?'invalid':null)} name="parent_menu" onChange={(e)=>handlechange(e)}>
									                    	<option value="0">parent menu</option>
									                    	{
									                    		listmenu.map((item,index)=>(
									                    			<>
									                    				<option value={item.id}>{item.menu_name}</option>
									                    			</>
									                    		))
									                    	}
									                    </select>
									                </div>
								                </div>


								                <div className="row">
					                        		<div className="col-sm-3" style={{textAlign:'right'}}>
								                    <label>Menu URL</label>
									                </div>
									                <div className="col-sm-9 form-group">
									                    <input type="text" className={"form-control "+(urlerror==true?'invalid':null)} name="menu_url" placeholder="enter menu url" onChange={(e)=>handlechange(e)} value={menu_url}/>
									                </div>
								                </div>

								                <div className="row">
					                        		<div className="col-sm-3" style={{textAlign:'right'}}>
								                    <label>Menu Order</label>
									                </div>
									                <div className="col-sm-9 form-group">
									                    <input type="number" className="form-control " name="menu_order"  onChange={(e)=>handlechange(e)} value={menu_order} />
									                </div>
								                </div>

								                <div className="col-md-12" style={{textAlign:'right'}}>
								                	<button className="btn btn-success" onClick={MenuSubmit}>Submit</button>
								                </div>


				                        	</div>
				                        	<div className="col-md-2"></div>
				                        </div>
				                    </div>
				                </div>
				            </div>
				        </div>
				    </section> 
				        </div>
				        
				    </section>
				</div>
				  <Footer/>
				 </div>
				         
				        </div>
		    </div>
		</>
		)
}


export default AddMenu;